module.exports = __webpack_public_path__ + "static/logo-2a3e44670ddae965ed995998abb2ff0e.svg";